var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { WebKitThemes } from "./WebKit/Themes";
import { CommonService } from "../Common/CommonService";
import { NativeContext } from "../Common/ICommonService";
export class ThemesService {
    GetServiceName() {
        return ThemesService.ServiceName;
    }
    SetThemeAsync(theme) {
        return __awaiter(this, void 0, void 0, function* () {
            switch (yield CommonService.GetNativeContextAsync()) {
                case NativeContext.AndroidGecko:
                    return;
                case NativeContext.IosWebkit:
                    return yield WebKitThemes.SetTheme(theme);
                default:
                    return;
            }
        });
    }
}
ThemesService.ServiceName = "ThemesService";
//# sourceMappingURL=ThemesService.js.map